var storeDateTimeNow = '2026-10-21 22:04';
if(typeof(chatbot) === 'undefined'){
  var chatbot = {
      settings:{
        workingHours:{
          weekdays:'9:00-19:00',
          saturday:'11:00-16:00',
          sunday:'',
          holidays:'2024-01-15,2024-05-27,2024-06-19,2024-07-4,2024-09-02,2024-11-28,2024-11-29,2024-12-24,2024-12-25'
        }
      },
      private:{
        getTodayInEST: function(){
          const currentDate = new Date();
          const formattedDate = currentDate.toLocaleString('en-US', { timeZone: 'America/New_York' });

          return new Date(formattedDate);
        },
        getCurrentTime: function(){
          try{
            return new Date(storeDateTimeNow);
          }catch(ex){
            console.error(ex);
          }
        },
        getHolidays: function(){
          let datesArray = [];
          let dateStrings = chatbot.settings.workingHours.holidays.split(',');
          for(let i in dateStrings){
            let convertedDate =new Date(dateStrings[i]);
            if(convertedDate.toString() !== 'Invalid Date') datesArray.push(convertedDate);
          }

          return datesArray;
        },
        getWeekdayName: function(date){
          switch(date.getDay()){
            case 0:
              return 'Sun';
            case 1:
              return 'Mon';
            case 2:
              return 'Tue';
            case 3:
              return 'Wed';
            case 4:
              return 'Thu'
            case 5:
              return 'Fri'
            case 6:
              return 'Sat'
            default:
              return 'Invalid';

          } 
        },
        isHoliday: function(now){
          let holidays = chatbot.private.getHolidays();
          for(let i in holidays){
            if(chatbot.private.isSameDate(now,holidays[i])) return true;
          }
          return false;
        },
        isInWorkingHours: function(today){
          let weekday = chatbot.private.getWeekdayName(today);
          if(weekday === 'Mon' || weekday === 'Tue' || weekday === 'Wed' || weekday === 'Thu' || weekday === 'Fri'){
            return chatbot.private.isInTimeRange(today,chatbot.settings.workingHours.weekdays);
          }else if(weekday === 'Sat'){
            return chatbot.private.isInTimeRange(today,chatbot.settings.workingHours.saturday);
          }else{
            return chatbot.private.isInTimeRange(today,chatbot.settings.workingHours.sunday);
          }
        },
        isInTimeRange: function(today,workingHours){
          var hoursList = workingHours.split('-');
          if(hoursList.length < 2) return false;

          var beginTimeString = hoursList[0];
          var endTimeString = hoursList[1];
          var beginTime = chatbot.private.getTodayInEST().setHours(beginTimeString.split(':')[0],beginTimeString.split(':')[1]);
          var endTime = chatbot.private.getTodayInEST().setHours(endTimeString.split(':')[0],endTimeString.split(':')[1]);

          return (beginTime <= today.getTime() && today.getTime() <= endTime);


        },
        isInWeekdaysWorkingHours:function(today){
          var weekdaysHoursList = chatbot.settings.workingHours.weekdays.split('-');
          if(weekdaysHoursList.length < 2) return false;
          var beginTimeString = weekdaysHoursList[0];
          var endTimeString = weekdaysHoursList[1];
          var beginTime = new Date(storeDateTimeNow).setHours(beginTimeString.split(':')[0],beginTimeString.split(':')[1]);
          var endTime = new Date(storeDateTimeNow).setHours(endTimeString.split(':')[0],endTimeString.split(':')[1]);

          return (beginTime <= today.getTime() && today.getTime() <= endTime);
        },
        isSameDateAlt: function(firstDate,secondDate){
          if(firstDate.getFullYear() !== secondDate.getFullYear()) return false;
          if(firstDate.getMonth() !== secondDate.getMonth()) return false;
          if(firstDate.getDate() !== secondDate.getDate()) return false;

          return true;

        },
        isSameDate: function(firstDate,secondDate){
          return firstDate.toLocaleDateString() === secondDate.toLocaleDateString();
        }
      },
      isWorkingTime: function(){
        let today = chatbot.private.getTodayInEST();
        if(chatbot.private.isHoliday(today)) return false;
        if(!chatbot.private.isInWorkingHours(today)) return false;
        return true;
      },
      showOffline: function(){
        $('body').append("<div class='offlineIcon'><span class='tooltiptext'></span></div>");
        $('.tooltiptext').html(`<p>The chat is currently offline.</p>`);

        $('.offlineIcon').click(function(){
          $('.tooltiptext').addClass('showTip');
        });

        $('.offlineIcon').mouseleave(function(){
          $('.tooltiptext').removeClass('showTip');
        });
      }
  }
}
$(window).click("textarea.chasitorText", function (e) {
  if (e.offsetX > $("textarea.chasitorText").width()) {
    const keyboardEvent = new KeyboardEvent("keydown", {
      code: "Enter",
      key: "Enter",
      charCode: 13,
      keyCode: 13,
      view: window,
      bubbles: true,
    });

    $("textarea.chasitorText")[0].dispatchEvent(keyboardEvent);
  }
});
$('.embeddedServiceHelpButton').on('click','div.embeddedServiceHelpButton button.uiButton.helpButtonEnabled span.embeddedServiceIcon',
  function (e) {
    console.log(e);
    if (e.target.localName != "button" && e.target.localName != "span") return;
    $("svg#ezGVUS6sedq1").appendTo("div.helpButton");
    $("svg#ezGVUS6sedq1").show();
    $("button.uiButton.helpButtonEnabled").hide();
    setTimeout(function () {
      //$('button.uiButton.helpButtonEnabled').css('opacity','1.0');

      $("svg#ezGVUS6sedq1").hide();
      $("button.uiButton.helpButtonEnabled").show();
    }, 4000);
  }
);
$(window).blur("button.uiButton.helpButtonEnabled", function () {
  $("button.uiButton.helpButtonEnabled").css("opacity", "1.0");
});

var initESW = function(gslbBaseURL) {
        embedded_svc.settings.displayHelpButton = chatbot.isWorkingTime();

if (!chatbot.isWorkingTime())
  chatbot.showOffline();
        embedded_svc.settings.language = '';
		
		embedded_svc.settings.extraPrechatFormDetails = [{
			"label": "Source",
			"value": "US",
			"displayToAgent": false,
			"transcriptFields":["Source__c"]
		}];

 

        embedded_svc.settings.enabledFeatures = ['LiveAgent'];
        embedded_svc.settings.entryFeature = 'LiveAgent';

 

        embedded_svc.init(
            'https://tobiidynavox.my.salesforce.com',
            'https://tobiidynavox.my.salesforce-sites.com/publicweb',
            gslbBaseURL,
            '00Dw0000000Csat',
            'TD_Chatbot',
            {
                baseLiveAgentContentURL: 'https://c.la2-c1-fra.salesforceliveagent.com/content',
                deploymentId: '5727Q000000HfBh',
                buttonId: '5737Q000000Hg3f',
                baseLiveAgentURL: 'https://d.la2-c1-fra.salesforceliveagent.com/chat',
                eswLiveAgentDevName: 'EmbeddedServiceLiveAgent_Parent04I7Q0000008f0MUAQ_189dbd59ab0',
                isOfflineSupportEnabled: false
            }
        );
    };

 

    if (!window.embedded_svc) {
        var s = document.createElement('script');
        s.setAttribute('src', 'https://tobiidynavox.my.salesforce.com/embeddedservice/5.0/esw.min.js');
        s.onload = function() {
            initESW(null);
        };
        document.body.appendChild(s);
    } else {
        initESW('https://service.force.com');
    }
